import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import useFetch from "../useFetch";
import { AuthContext } from "src/context/authContext";

import { APIEndpoints } from "src/types/apiTypes";
import { createUserAPIResponseType } from "./types";



const useDemoUserView = () => {
  const { userData, updateUserData } = useContext(AuthContext);
  const navigate = useNavigate()



  const { data: updateUserApiResponse, mutate: addNewUser } =
    useFetch<createUserAPIResponseType>(APIEndpoints.USER_UPDATE, {}, { userId: userData?.id });

  useEffect(() => {
    if (updateUserApiResponse) {
      if (updateUserApiResponse.status.data && updateUserApiResponse.status.data.user) {
        updateUserData({
          ...userData,
          ...updateUserApiResponse.status.data.user,
          reset_demo_cases: updateUserApiResponse.status.data.navbar?.reset_demo_cases,
          stats_view: updateUserApiResponse.status.data.navbar?.stats_view,
          demo_user_view: updateUserApiResponse.status.data.navbar?.demo_user_view,
          eob_button: updateUserApiResponse.status.data.navbar.eob_button || false,
        });
        setTimeout(() => navigate(0), 300)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateUserApiResponse]);

  const submitForm = async (values: unknown) => {
    addNewUser({ user: values });
  };



  return { submitForm }
}

export default useDemoUserView;
